export const ENTITY_ZOOM = 15;
export const MAX_ZOOM = 20;
export const MIN_ZOOM = 0;
export const DOUBLE_CLICK_THRESHOLD = 300;
